import Page from "@jumbo/shared/Page";
import AuthenticateAndRolesMiddleware from "../Middleware";


const routesName = "/dashboards/billing";
const modules = "billing";

export const billingRoute = [
  {
    middleware: [
      {
        element: AuthenticateAndRolesMiddleware,
        fallbackPath: "/login",
        module: modules
      },
    ],
    routes: [
      {
        path: `${routesName}`,
        // element: <Page component={Home} />
      },
      {
        path: `${routesName}/add`,
        // element: <Page component={AdminCustomers} />,
      },
      {
        path: `${routesName}/edit`,
        // element: <Page component={EditCloudstratClient} />,
      },
    ],
  },]
  